import React from "react";
//css & images
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer" style={{ opacity: "0" }}>
      © Engati
      <div className="footer-links-divider"></div>
      <a className="link" href="https://www.engati.com/termsofuse" target="_blank" rel="noopener noreferrer">Terms of use</a>
      <div className="footer-links-divider"></div>
      <a className="link" href="https://www.engati.com/privacypolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    </div>
  );
};

export default Footer;